<li
  #subMenu
  (mouseenter)="subMenuShow(subMenu)"
  (mouseleave)="subMenuHide(subMenu)"
  class="dropdown position-relative custom-menu"
  [ngClass]="pagelet()?.stringParam('ShowInMobileMenu') === 'false' ? 'd-xs-none' : ''"
>
  <div class="extenal-nav-link">
    @if (pagelet()?.stringParam('IsRouterLink') === 'true') {
    <a
      [routerLink]="pagelet()?.stringParam('MainNavigationLink')"
      [attr.data-testing-id]="pagelet()?.stringParam('MainNavigationId')"
      [ngStyle]="{ width: '100%' }"
      class="main-navigation-link"
      [ngClass]="!isSubNavPresent ? 'no-sub-menu' : ''"
    >
      {{ pagelet()?.stringParam('MainNavigationTitle') }}
    </a>
    } @else {
    <a
      [href]="pagelet()?.stringParam('MainNavigationLink')"
      [attr.data-testing-id]="pagelet()?.stringParam('MainNavigationId')"
      class="main-navigation-link"
      [ngClass]="!isSubNavPresent ? 'no-sub-menu' : ''"
    >
      {{ pagelet()?.stringParam('MainNavigationTitle') }}
    </a>
    }
    <a [routerLink]="[]" class="dropdown-toggle" (click)="openToggle()" [ngClass]="!isSubNavPresent ? 'd-none' : ''">
      @if (plusIcon) {
      <fa-icon [icon]="['fas', 'plus']" />
      } @else {
      <fa-icon [icon]="['fas', 'minus']" />
      }
    </a>
  </div>
  @if (pagelet()?.stringParam('DisableSubMenu') !== 'true') {
  <ul
    #subNav
    class="category-level1 dropdown-menu externalLink"
    [ngClass]="!plusIcon ? 'open' : ''"
    [ngClass]="!isSubNavPresent ? 'd-none' : ''"
  >
    @for (subNavIndex of subNavCount; track subNavIndex) { @if (pagelet()?.stringParam('SubNavigationTitle' +
    subNavIndex)) {
    <li
      class="externalLinkItem"
      [ngClass]="pagelet()?.stringParam('ShowInMobileMenu' + subNavIndex) === 'false' ? 'd-xs-none' : ''"
    >
      @if (pagelet()?.stringParam('IsRouterLink' + subNavIndex) === 'true') {
      <a [routerLink]="pagelet()?.stringParam('SubNavigationLink' + subNavIndex)">{{
        pagelet()?.stringParam('SubNavigationTitle' + subNavIndex)
      }}</a>
      } @else {
      <a [href]="pagelet()?.stringParam('SubNavigationLink' + subNavIndex)">{{
        pagelet()?.stringParam('SubNavigationTitle' + subNavIndex)
      }}</a>
      }
    </li>
    } }
  </ul>
  }
</li>
